import { NotFound } from "@/components/NotFound";
import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: () => <NotFound />,
});
